import $ from 'jquery';

$(document).ready(function () {
  acfCtaBlock();
});

function acfCtaBlock() {
  $('.js-acf-cta').each(function () {});
}
